/**
 * Rich Text Nested Lists Processor 
 * Converts custom tags (<l2>, <l3>, <l4>) to properly nested HTML lists
 * 
 * Guard prevents multiple executions even if script is included multiple times
 */

(function() {
    'use strict';
  
    // Guard against multiple executions
    if (window.richTextNestedListsInitialized) {
      return;
    }
    window.richTextNestedListsInitialized = true;
  
    document.addEventListener('DOMContentLoaded', () => {
      const richTextBlocks = document.querySelectorAll('.richtext-block');
  
      richTextBlocks.forEach(block => {
        try {
          let html = block.innerHTML;
          
          // Check if any nested list tags exist
          if (!html.includes('&lt;l2&gt;') && !html.includes('&lt;l3&gt;') && !html.includes('&lt;l4&gt;')) {
            return;
          }
  
          // Define nested list level configurations
          const levelConfig = [
            { level: 2, tag: 'l2' },
            { level: 3, tag: 'l3' },
            { level: 4, tag: 'l4' }
          ];
  
          // Process all nested list levels
          levelConfig.forEach(({ level, tag }) => {
            const openTag = `&lt;${tag}&gt;`;
            const closeTag = `&lt;/${tag}&gt;`;
            
            if (html.includes(openTag)) {
              html = html.replaceAll(
                `<li>${openTag}`,
                `<li class="level-${level}-list-item"><ul class="level-list level-${level}-list"><li>`
              );
              html = html.replaceAll(closeTag, '</li></ul>');
            }
          });
  
          block.innerHTML = html;
        } catch (error) {
          console.error('Error processing nested lists in richtext block:', error);
        }
      });
    });
  })();
  